import { Select } from '@material-ui/core';
import { Drawer } from '@material-ui/core';
import SahamDialog from 'components/SahamDialog';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const Container = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .title {
    text-align: left;
    text-transform: inherit;
    font-size: 18px;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 10px;
    color: #374065;
    display: inline;
    font-weight: 500;
    font-family: Roboto;
  }
  .subContainer {
    display: flex;
    justify-content: space-around;
    margin-top: 25px;
  }
  .sub-input {
    width: 33%;
    margin-right: 10px;
    font-size: 14px;
  }
  .input-checkbox {
    margin-right: 30px;
  }
  .input-1-3 {
    width: 25%;
    margin-bottom: 33px;
  }
  .input-2-3 {
    width: 73%;
    margin-bottom: 33px;
  }
  .input-3 {
    width: 32%;
    margin-bottom: 33px;
  }
  .title {
    width: 183px;
    height: 21px;
    text-align: left;
    font-size: 24px;
    font-weight: medium;
    color: #2b2727;
  }
  .checkdiv {
    align-items: center;
    display: flex;
    margin-left: 10px;
  }
  .text {
    text-align: left;
    font-size: 15px;
    color: #374065;
    margin-right: 17px;
    font-weight: Bold;
    font-family: Roboto;
  }
  .hideContent {
    visibility: hidden;
  }
  .MuiFormLabel-root {
    font-size: 13px;
  }
  .radio-label-style {
    font-size: 14px;
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .MuiFormLabel-root.Mui-disabled {
    font-size: 20px;
    color: #666;
  }
`;

export const FraudContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  margin: 10px;
`;
export const FraudFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
  & > * {
    margin: 25px;
  }
  width: 50%;
`;

export const FraudMotifDialogWrapper = styled(SahamDialog)`
  display: flex;
  flex-direction: column;
  &.fraud-motif-content {
    min-width: 500px;
    min-height: 30vh;
  }
`;

export const VictimContainer = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .victim-bloc-title {
    text-align: left;
    font-size: 24px;
    white-space: nowrap;
    letter-spacing: 0;
    margin-left: 10px;
    font-weight: 500;
    font-family: Roboto;

    color: #2b2727;
  }
  .subContainer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .input {
    width: 23%;
    margin-bottom: 33px;
    font-size: 14px;
    .input-checkbox {
      margin-right: 30px;
    }
  }
  .input-gender {
    margin-left: 15px;
  }
  .input-1-3 {
    width: 25%;
    margin-bottom: 20px;
  }
  .input-2-3 {
    width: 100%;
    margin-bottom: 20px;
  }
  .input-3 {
    width: 32%;
    margin-bottom: 20px;
  }
  .input-4 {
    width: 90%;
    margin-bottom: 20px;
    margin-left: 20px;
  }
  .input-4-1 {
    width: 90%;
    margin-bottom: 20px;
  }

  .checkdiv {
    align-items: center;
    display: flex;
    margin-top: -18px;
    margin-bottom: -40px;
  }
  .text {
    text-align: left;
    font-size: 15px;
    color: #374065;
    margin-right: 17px;
    font-weight: bold;
    font-family: Roboto;
  }
  .deceased-title {
    font-size: 20px;
    margin-bottom: 10px;
    display: flex;
  }
  .victime-title-div {
    width: 98%;
    height: 36px;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-bottom: 15px;
    position: relative;
  }
  .victime-title {
    text-align: left;
    font: 14px;
    font-weight: bold;
    letter-spacing: 0;
    color: #0072c6;
    margin-left: 10px;
    top: 50%;
    position: absolute;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .delete-title {
    text-align: left;
    font: 14px;
    font-weight: bold;
    letter-spacing: 0;
    color: #384164;
    margin-left: 10px;
    top: 50%;
    position: absolute;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    display: flex;
    justify-content: space-around;
  }
  .delete-victime {
    float: right;
    margin-left: 90%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
  }
  .delete-icon {
    color: #384164;
    top: 50%;
    right: 9.5%;
    position: absolute;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .add-victim-paper {
    width: 160px;
    height: 106px;
    border-radius: 5px;
    background: #f8f8f8;
  }
  .victim-container {
    left: 328px;
    margin-top: 20px;
    margin-bottom: 25px;
    width: 100%;
  }
  .add-viction-btn {
    width: 160px;
    height: 36px;
    text-align: center;
    font-size: 14px;
  }
  .add-beneficiary-btn {
    margin-left: auto;
  }
  .add-victim-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 106px;
    border-radius: 5px;
  }
  .add-eligibility-victim {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    height: 106px;
    border-radius: 5px;
  }
  .add-eligibilty-btn {
    width: 160px;
    height: 36px;
    text-align: center;
    font-size: 14px;
  }
  .iconDiv {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .icon {
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 30px;
    background: #f2f2f2;
    margin-bottom: 10px;
  }
  .victims {
    margin-top: 30px;
  }
  .label-input {
    font-size: 13px;
  }
  .MuiFormLabel-root {
    font-size: 13px;
    color: #4f4f4f;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .deceaseBlock {
    margin-bottom: 40px;
  }
  .beneficiary {
    margin-bottom: 10px;
  }
  .accordion-form-container {
    margin-top: '30px';
    margin-inline: '25px';
  }
  .MuiInputLabel-shrink {
    font-size: 20px;
    color: #666;
  }
  .MuiInputBase-input.Mui-disabled {
    font-weight: 500;
  }
  .MuiAutocomplete-inputRoot .MuiAutocomplete-input {
    font-weight: 500;
  }
  .victim-bloc-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: flex-start !important;
    margin-top: -5px !important;
  }
  .grid-input {
    margin-bottom: 15px;
  }
`;

export const StyledSelect = styled(Select)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  .MuiSelect-icon {
    color: black;
  }
  font-weight: 500;
`;
export const StyledCard = {
  backgroundColor: COLORS.LIGHT_ORANGE,
  padding: '8px 16px 8px 8px',
  width: 'fit-content',
};
export const StyledText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  fontWeight: 500,
};

export const ContainerFraude = styled.div`
  &&.container {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  .title {
    text-align: left;
    text-transform: inherit;
    font-size: 24px;
    letter-spacing: 0;
    margin-left: 10px;
    margin-bottom: 30px;
    color: #2b2727;
    display: inline;
    font-weight: 500;
    font-family: Roboto;
  }
  .MuiPaper-root {
    box-shadow: 0px 1px 3px #0000001f;
  }
  .subContainer {
    display: flex;
    justify-content: space-around;
    margin-top: 25px;
  }
  .smallSubContainer {
    display: flex;
    margin-top: 25px;
  }
  .input {
    width: 23%;
    margin-bottom: 33px;
  }
  .input-3 {
    width: 32%;
    margin-bottom: 33px;
  }
  .input-4 {
    width: 32%;
    margin-left: 30px;
    margin-bottom: 33px;
  }
  .checkdiv {
    align-items: center;
    display: flex;
    margin-left: 10px;
  }
  .text {
    text-align: left;
    font-size: 15px;
    color: #374065;
    margin-right: 17px;
    font-weight: Bold;
    font-family: Roboto;
  }
  .hideContent {
    visibility: hidden;
  }
  .label-input {
    font-size: 13px;
  }
  .MuiFormLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;

export const DrawerContainer = styled(Drawer)`
  .MuiDrawer-paper {
    overflow-y: visible;
  }
  .MuiTimelineOppositeContent-root {
    flex: unset;
    padding: 0;
  }
  .MuiTimelineDot-root {
    color: rgba(84, 147, 189, 1);
    background-color: rgba(212, 236, 255, 1);
    box-shadow: unset;
    width: 12px;
    height: 12px;
  }
`;

export const DrawerDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: fit-content;
  min-width: 375px;
  .divider {
    width: 100%;
    background: ${COLORS.DEVIDER_GREY};
    height: 2px;
    min-width: 375px;
  }
  .titleConatainer {
    height: 64px;
    padding-left: 24px;
    padding-top: 23px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
  }
  .title {
    color: ${COLORS.BLUE};
    text-align: left;
    font-size: 15px;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    color: #0075c9;
    opacity: 1;
  }
  .actions {
    padding: 10px;
  }
  .action-buttons-container {
    padding: 0 10px;
  }
  .saveButton,
  .cancelButton {
    width: 126px;
    height: 36px;
  }
  .disabledSaveButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
  .content {
    overflow-y: scroll;
    height: 90%;
  }
`;

export const StyledDiv = styled.div`
  width: 549px;
  display: flex;
  flex-direction: column;
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
`;
